import React from "react";

function MrbGridEmptyState() {
    return <div>There is no data.</div>;
}

export default MrbGridEmptyState;
